import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Our Story", to: "/our-story" },
  { label: "Highlights", to: "/highlights" },
  { label: "Locations", to: "/locations" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sd-header" data-testid="site-header">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 py-4">
        <Link to="/" className="sd-logo" data-testid="site-logo">
          Sub Delicious
        </Link>

        <nav className="sd-nav hidden md:flex items-center gap-1" data-testid="desktop-nav">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={pathname === n.to ? "active" : ""}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#a40202] border-t border-[#8a0101]" data-testid="mobile-nav">
          <div className="flex flex-col px-5 py-3">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="sd-nav-mobile py-3 text-white font-display text-lg border-b border-[#8a0101]"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
